import { AuthGuard } from '../../shared/services';
import { SeekersComponent } from './seekers.component';
import { Route } from '@angular/router';
import { SeekersListeRoutes } from '../seekers/seekers_list/seekers-list.routes';

export const SeekersRoutes: Route[] = [
  {
    path: 'seekers',
    component: SeekersComponent,
    canActivate: [AuthGuard],
    children: [...SeekersListeRoutes]
  }
];
